import React from "react";
import PropTypes from "prop-types";
import ControlTemplate from "../BaseControls/ControlTemplate";
import DateInput from "../BaseControls/DateInput";
import {controlPropTypes} from "../formhelpers";
import maskFormats from "../BaseControls/InputMask/MaskConstants";

export default class Calendar extends React.Component {
    render() {
        const { descriptor } = this.props;

        const { granularity } = descriptor.config;

        let format = maskFormats.armus_date_day;
        let showCalendar = true;
        if (granularity === "DAY") {
            format = maskFormats.armus_date_day;
            showCalendar = true;
        } else if (granularity === "MONTH") {
            format = maskFormats.armus_date_month;
            showCalendar = true;
        } else if ( granularity === "YEAR") {
            format = maskFormats.armus_date_year;
            showCalendar = true;
        }

        return (
            <ControlTemplate {...this.props} className="date-field" >
                <DateInput
                    {...this.props}
                    maskFormat={format}
                    showCalendar={showCalendar}
                />
            </ControlTemplate>
        );
    }
}

Calendar.propTypes = controlPropTypes({
    granularity: PropTypes.string
});



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/DateField/calendar.js